import { render, staticRenderFns } from "./CardTemplateNewsletters.vue?vue&type=template&id=46e69d60&scoped=true&"
import script from "./CardTemplateNewsletters.vue?vue&type=script&lang=js&"
export * from "./CardTemplateNewsletters.vue?vue&type=script&lang=js&"
import style0 from "./CardTemplateNewsletters.vue?vue&type=style&index=0&id=46e69d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e69d60",
  null
  
)

component.options.__file = "CardTemplateNewsletters.vue"
export default component.exports